var map = {
	"./1000.jpg": 3209,
	"./1001.jpg": 6332,
	"./1002.jpg": 987,
	"./1003.jpg": 2942,
	"./1004.jpg": 8565,
	"./1005.jpg": 4248,
	"./1006.jpg": 4231,
	"./1007.jpg": 6490,
	"./1008.jpg": 7601,
	"./1009.jpg": 5796,
	"./1010.jpg": 6402,
	"./1011.jpg": 9071
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9305;